import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Environment } from '../../environment/environment.model';

@Injectable()
export class TenantHeaderInterceptor implements HttpInterceptor {
  constructor(@Inject('env') private environment: Environment) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(this.environment.apiUrl) || req.headers.has('X-Tenant-ID')) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          'X-Tenant-ID': this.environment.tenantId,
        },
      }),
    );
  }
}